import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

import StepConnector from './StepConnector';

const getStyles = (orientation) => ({
  root: {
    display: 'flex',
    flexDirection: orientation === 'horizontal' ? 'row' : 'column',
    alignContent: 'center',
    alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
    justifyContent: 'space-between',
    positon: 'relative',
  },
});

class Stepper extends Component {
  getChildContext() {
    const { orientation } = this.props;
    return { stepper: { orientation } };
  }

  render() {
    const { activeStep, children, connector, linear, orientation } = this.props;

    /**
     * One day, we may be able to use real CSS tools
     * For now, we need to create our own "pseudo" elements
     * and nth child selectors, etc
     * That's what some of this garbage is for :)
     */
    const numChildren = Children.count(children);
    const steps = Children.map(children, (step, index) => {
      const controlProps = { index };

      if (activeStep === index) {
        controlProps.active = true;
      } else if (linear && activeStep > index) {
        controlProps.completed = true;
      } else if (linear && activeStep < index) {
        controlProps.disabled = true;
      }

      if (index + 1 === numChildren) {
        controlProps.last = true;
      }

      return [
        index > 0 && connector,
        step ? React.cloneElement(step, Object.assign(controlProps, step.props)) : null,
      ];
    });

    return <div style={getStyles(orientation)}>{steps}</div>;
  }
}

Stepper.propTypes = {
  /**
   * Set the active step (zero based index). This will enable `Step` control helpers.
   */
  activeStep: PropTypes.number,
  /**
   * Should be two or more `<Step />` components.
   */
  children: PropTypes.node,
  /**
   * A component to be placed between each step.
   */
  connector: PropTypes.node,
  /**
   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
   */
  linear: PropTypes.bool,
  /**
   * The stepper orientation (layout flow direction)
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
};

Stepper.defaultProps = {
  connector: <StepConnector />,
  orientation: 'horizontal',
  linear: true,
};

Stepper.childContextTypes = { stepper: PropTypes.object };

export default Stepper;
